import { render, staticRenderFns } from "./StudentCalendarComponent.vue?vue&type=template&id=6d7f1067&"
import script from "./StudentCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./StudentCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./StudentCalendarComponent.vue?vue&type=style&index=0&id=6d7f1067&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports